export const OPTIONS = {
  INCLUDED: 'INCLUDED',
  EXCLUDED: 'EXCLUDED',
  NONE: 'NONE',
}

export default {
  OPTIONS,
}



// WEBPACK FOOTER //
// ./src/constants/vat.js